export enum LICENSING_TYPES {
  COLLEGES = 'colleges',
}

const LicensingSearchGridBuilderComponent = {
  name: '_LicensingSearchGrid_',
  canHaveChildren: false,
  inputs: [
    {
      name: 'licensingType',
      friendlyName: 'Licensing Type',
      helperText:
        'Select a licensing type to render the corresponding licensing search grid.',
      type: 'string',
      enum: [LICENSING_TYPES.COLLEGES],
      defaultValue: LICENSING_TYPES.COLLEGES,
      localized: true,
    },
    {
      name: 'header',
      friendlyName: 'Header Text',
      helperText: 'Modify the header text for the licensing search grid.',
      type: 'string',
      defaultValue: 'Find your team spirit',
      localized: true,
    },
    {
      name: 'searchPlaceholder',
      friendlyName: 'Search Input Placeholder Text',
      helperText: 'Modify the placeholder text for the search input field.',
      type: 'string',
      defaultValue: 'Search teams',
      localized: true,
    },
    {
      name: 'userInterestSubmissionForm',
      friendlyName: 'User Interest Submission Form',
      type: 'object',
      defaultValue: {
        hasUserInterestSubmissionForm: true,
        promptCopy: 'Don’t see your team?',
        promptAnchorLink: 'Let us know!',
        floatingButtonCopy: "Can't Find Your Team?",
        header: 'Can’t find what you are looking for?',
        copy: 'Let us know so we can add it! Submitting your team helps us make sure they’re represented in our future drops!',
        placeholder: 'Enter your team',
        submitCTA: 'Submit',
        submitSuccess: 'Your request has been submitted',
      },
      subFields: [
        {
          name: 'hasUserInterestSubmissionForm',
          friendlyName: 'Has User Interest Submission Form?',
          helperText:
            'Should this licensing search grid display a user interest submission form?',
          type: 'boolean',
        },
        {
          name: 'promptCopy',
          friendlyName: 'User Interest Prompt Copy Text',
          helperText: 'Modify user interest submission form prompt text.',
          type: 'string',
          localized: true,
          showIf: (options: any) =>
            options.get('hasUserInterestSubmissionForm'),
        },
        {
          name: 'promptAnchorLink',
          friendlyName: 'User Interest Prompt Anchor Link Text',
          helperText:
            'Modify user interest submission form anchor link text here.',
          type: 'string',
          localized: true,
          showIf: (options: any) =>
            options.get('hasUserInterestSubmissionForm'),
        },
        {
          name: 'floatingButtonCopy',
          friendlyName: 'Floating Button Copy Text',
          helperText:
            'Modify user interest submission form floating button copy text.',
          type: 'string',
          localized: true,
          showIf: (options: any) =>
            options.get('hasUserInterestSubmissionForm'),
        },
        {
          name: 'header',
          friendlyName: 'User Interest Header Text',
          helperText: 'Modify user interest submission form header text here.',
          type: 'string',
          localized: true,
          showIf: (options: any) =>
            options.get('hasUserInterestSubmissionForm'),
        },
        {
          name: 'copy',
          friendlyName: 'User Interest Copy Text',
          helperText: 'Modify user interest submission form copy text.',
          type: 'string',
          localized: true,
          showIf: (options: any) =>
            options.get('hasUserInterestSubmissionForm'),
        },
        {
          name: 'placeholder',
          friendlyName: 'User Interest Input Placeholder Text',
          helperText: 'Modify user interest submission form input placeholder.',
          type: 'string',
          localized: true,
          showIf: (options: any) =>
            options.get('hasUserInterestSubmissionForm'),
        },
        {
          name: 'submitCTA',
          friendlyName: 'User Interest Submit CTA Text',
          helperText: 'Modify user interest submission form submit CTA text.',
          type: 'string',
          localized: true,
          showIf: (options: any) =>
            options.get('hasUserInterestSubmissionForm'),
        },
        {
          name: 'submitSuccess',
          friendlyName: 'User Interest Submit Success Text',
          helperText:
            'Modify user interest submission form submit success text.',
          type: 'string',
          localized: true,
          showIf: (options: any) =>
            options.get('hasUserInterestSubmissionForm'),
        },
      ],
    },
    {
      name: 'emptyList',
      friendlyName: 'Empty List',
      type: 'object',
      defaultValue: {
        header: 'Tell Us your school',
        ctaCopy: 'Let Us Know',
      },
      helperText: 'Please note that Mobile App only supports empty list UI.',
      subFields: [
        {
          name: 'header',
          friendlyName: 'Empty List Header Text',
          helperText: 'Modify empty list header text here.',
          type: 'string',
          localized: true,
        },
        {
          name: 'ctaCopy',
          friendlyName: 'Empty List CTA Copy Text',
          helperText: 'Modify empty list CTA copy text here.',
          type: 'string',
          localized: true,
        },
      ],
    },
  ],
} as const;

export default LicensingSearchGridBuilderComponent;
